/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals  jQuery:true, TweenMax:true, window:true, navigator:true, TimelineMax:true, Spinner:true, Sector:true, generic: true, site: true*/

Drupal.behaviors.ModuleVBBoutique = {
  attach: function (context, settings) {
    // /////////////////////////////////
    // BEGIN: Utility Functions
    // /////////////////////////////////
    /**
		* @function quickshop
		* @description Creates quickshop functionality for target element(s)
		* @param {Object} options - Options for quickshop function
		* @param {boolean} debug [options.debug=false] - Whether to display debug messages or not
		* @returns {jQuery} - Target elements this function was called on
		*/
    jQuery.fn.quickshop = function (options) {
      var $ = jQuery,
        $this = $(this),
        productIds = [],
        defaults = { debug: false };

      // Note: QUICKSHOP SWITCH
      // Quickshop doesn't work on dynamic.li, we put this in so we dont ever have to worry about commenting out this block again
      if (window.location.href.indexOf('dynamic.li') > -1) {
        return;
      }

      options = $.extend(defaults, options);

      // Build list of product ids
      // NOTE: each quickshop <a> should have a data-productID="PROD###" where ### is the specific product ID
      // If not it will attempt to parse the product url ex url : /product/12883/6600/Product-Catalog/Makeup/Accessories/Brushes/Concealer-Brush
      $this.each(function () {
        var $this = $(this),
          productId,
          splitPathName,
          pathname;

        if (typeof $this.data('product') === 'undefined') {
          pathname = this.pathname;
          if (pathname.charAt(0) !== '/') {
            pathname = '/' + pathname;
          }

          splitPathName = pathname.split('/');
          if (splitPathName.length >= 3) {
            productId = 'PROD' + splitPathName[3];
          }
        } else {
          productId = $this.data('product');
        }

        if (typeof productId !== 'undefined' && (/^(PROD\d+)$/).test(productId)) {
          if (options.debug) {
            console.log('quickshop: Found product id for : ', $this, ' with ' + productId);
          }
          productIds.push(productId);
        } else if (options.debug) {
          console.log('quickshop: Failed to find product id for : ', $this, ' with ID ' + productId, (/^(PROD\d+)$/).test(productId));
        }
      });

      if (options.debug) {
        console.log('quickshop: Found products: ' + productIds);
      }

      // Run the fetch for all required fields for quickshop
      generic.jsonrpc.fetch({
        method: 'prodcat',
        params: [
          {
            products: productIds,
            'sku_fields': [
              'HEX_VALUE_STRING',
              'INVENTORY_STATUS',
              'LARGE_IMAGE',
              'MEDIUM_IMAGE',
              'PRICE',
              'PRODUCT_ID',
              'PRODUCT_SIZE',
              'SHADENAME',
              'SKU_BASE_ID',
              'SKU_ID',
              'XL_IMAGE',
              'XL_SMOOSH',
              'formattedPrice'
            ],
            product_fields: [
              'ATTRIBUTE_DESC_1',
              'ATTRIBUTE_DESC_2',
              'ATTRIBUTE_LABEL_1',
              'ATTRIBUTE_LABEL_2',
              'PRODUCT_DETAILS_MOBILE',
              'DEFAULT_CAT_ID',
              'DISPLAY_STATUS',
              'FAMILY_CODE',
              'MPP_DESC_1',
              'MPP_DESC_2',
              'PRODUCT_ID',
              'PROD_RGN_NAME',
              'PROD_RGN_SUBHEADING',
              'RATING_IMAGE',
              'SHORT_DESC',
              'TOTAL_REVIEW_COUNT',
              'priceRange',
              'shaded',
              'sized',
              'skus',
              'url'
            ]
          }
        ],
        onSuccess: function (results) {
          var productResults;

          if (typeof results === 'undefined' || typeof results.getValue() === 'undefined' || typeof results.getValue().products === 'undefined' || results.getValue().products.length === 0) {
            return;
          }

          productResults = results.getValue().products;

          if (options.debug) {
            console.log('quickshop: Success: ', productResults);
          }

          if (productResults.length === 0) {
            return;
          }

          // Match product ID with product data with same product ID and save as a data attribute
          $this.each(function () {
            var $this = $(this),
              product = $this.data('product'),
              productResult,
              p = 0;

            // Must have a filled product ID
            if (typeof product === 'undefined' || product.length === 0) {
              if (options.debug) {
                console.log('quickshop: Failed to associate product ID: ' + product + ' data with: ', $this);
              }

              return;
            }

            for (p = 0; p < productResults.length; p++) {
              productResult = productResults[p];
              if (product === productResult.PRODUCT_ID) {
                if (options.debug) {
                  console.log('quickshop: Successfully associated product ID: ' + product + ' data with: ', $this);
                }
                $this.data('product_data', productResult);

                return;
              }
            }
          });

          // Event call to open quickshop
          $this.unbind('click').click(function (e) {
            var $this = $(this);

            if (options.debug) {
              console.log('quickshop: Attemping open ' + $this + ' with ' + $this.data('product') + ' with data ' + $this.data('product_id'));
            }

            // Do not do anything if there isn't any product_data associated with the quickshop
            if (typeof $this.data('product_data') === 'undefined') {
              return;
            }

            e.preventDefault();
            // Launch the quickshop
            site.quickshop($this.data('product_data'));
          });
        },
        onFail: function (error) {
          if (options.debug) {
            console.log('quickshop: Error : With Error ', error);
          }
        }
      });

      return $this;
    };

    /**
		* @function quickshop
		* @description A helper function that calls jQuery.fn.quickshop, created to replicate older quickshop functionality pre-jQuery plugin rewrite
		* @returns {jQuery} - A jQuery object containing <a> with shop_now classes found in the document
		*/
    function quickshop() {
      return jQuery('a.quickshop').quickshop();
    }

    /**
		* @function getInternetExplorerVersion
		* @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
		* @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
		* @returns {Number} -1 if not any IE version, any other number otherwise
		*/
    function getInternetExplorerVersion() {
      var rv = -1,
        ua,
        re,
        verStringArr;

      // works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
      if (navigator.appName === 'Microsoft Internet Explorer') {
        ua = navigator.userAgent;
        re = /'MSIE ([0-9]{1,}[\.0-9]{0,})'/;
        if (re.exec(ua) !== null) {
          rv = parseFloat(RegExp.$1);
        }
      } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Trident') > -1) {
        rv = 11;
      } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Edge') > -1) {
        ua = navigator.userAgent;
        re = /'Edge\/([0-9]{1,}[\.0-9]{0,})'/;
        verStringArr = re.exec(ua);
        if (verStringArr.length !== 0) {
          rv = Math.floor(parseFloat(verStringArr[0].split('/')[1]));
        }
      }

      return rv;
    }

    // /////////////////////////////////
    // END: Utility Functions
    // /////////////////////////////////

    // /////////////////////////////////
    // BEGIN: Boutique Implementation
    // /////////////////////////////////
    (function () {
      'use strict';

      // DOM Elements
      var MAIN = new Sector({
          loop: true,
          debug: false
        }),
        $window = $(window),
        $body = $('body'),
        $siteContainer = $('#vb_container'),
        // debug
        debug = true, // window.location.search.indexOf('debug=true') !== -1,
        // Platform check vars
        mobileSize,
        isMobile,
        isIpad,
        isDesktop,
        ieVersion,
        // Deeplink
        deeplinkMethods;

      {
        mobileSize = 640;
        // Initial mobile checks (additional checks will be needed for 'desktop mobile' sizes)
        isMobile = typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        isDesktop = !isMobile;
        isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;
        ieVersion = getInternetExplorerVersion();

        // set classes for desktop/mobile/ipad/ie
        if (isIpad) {
          $body.addClass('ipad');
        } else {
          $body.addClass(isMobile ? 'mobile' : 'desktop');
        }

        if (ieVersion !== -1) {
          $body.addClass('ie');
        }

        if (ieVersion === 9) {
          $body.addClass('ie-9');
        }

        if (isDesktop) {
          isMobile = $(window).width() <= 640;
          if (isMobile) {
            $body.addClass('mobile');
          }
        }
      }

      deeplinkMethods = {
        deeplinkSectionIDPart: 'vb_section-',
        deeplinkSectionClass: '.vb_section',
        deeplinking: false,
        // Takes the window's hash and grabs the appropriately defined target and feeds it to the section
        deeplink: function () {
          var targetSectionNum,
            $targetSection;

          if (debug) {
            console.log('deeplink fn', window.location.hash);
          }
          if (window.location.hash.length !== 0) {
            targetSectionNum = window.location.hash.split('/')[1];
            $targetSection = $('#' + deeplinkMethods.deeplinkSectionIDPart + targetSectionNum);

            if (typeof $targetSection.data('section') !== 'undefined' && $targetSection.length !== 0) {
              deeplinkMethods.deeplinking = true;
              $targetSection.data('section').deeplink();
            }

            return true;
          }

          return false;
        },
        getDeeplink: function () {
          var targetSectionNum,
            $targetSection;

          if (window.location.hash.length !== 0) {
            targetSectionNum = window.location.hash.split('/')[1];
            $targetSection = $('#' + deeplinkMethods.deeplinkSectionIDPart + targetSectionNum);

            if ($targetSection.length !== 0) {
              return $targetSection;
            }
          }

          return $siteContainer.find(deeplinkMethods.deeplinkSectionClass).first();
        },
        // Set the deeplink target if its new and don't disturb search history
        setDeeplink: (function () {
          var current = '#/';

          return function (hash) {
            if (hash === current) {
              return false;
            }
            current = hash;
            location.replace(hash);
          };
        }()),
        setPageview: (function () {
          var currentPage = '',
            currentView = '';

          return function (page, view) {
            if (typeof page === 'undefined') {
              return;
            }
            if (typeof view === 'undefined') {
              view = '';
            }
            if (currentPage === page && currentView === view) {
              return;
            }
            currentPage = page;
            currentView = view;
            $body.trigger('PageView', [currentPage, currentView]);
          };
        }())
      };

      // Customize global sector JS functionality here
      /**
			* @function generateSection
			* @description Generates Sector JS arguments from a given section and options
			* @param {jQuery} $element Section to generate section data JS arguments from
			* @param {object} options  Object to customize this function's functionality
			* @returns {object} Prepared argument for Sector JS
			*/
      function generateSection($element, options) {
        var elementId = $element.attr('id');

        if (typeof $element === 'undefined' || $element.length === 0) {
          return;
        }

        options = $.extend({}, options);

        return {
          element: $element,
          load: function () {
            if (debug) {
              console.log(elementId + ': load');
            }

            if (typeof options.load === 'function') {
              options.load.apply(this, arguments);
            }
          },
          unload: function () {
            if (debug) {
              console.log(elementId + ': unload');
            }

            $element.removeClass('active');

            if (typeof options.unload === 'function') {
              options.unload.apply(this, arguments);
            }
          },
          update: function () {
            if (debug) {
              console.log(elementId + ': update');
            }

            if (arguments[0] >= 0.4) {
              $element.addClass('active');
            } else {
              $element.removeClass('active');
            }

            // Do not allow updates if deeplinking
            if (deeplinkMethods.deeplinking) {
              return;
            }

            if (typeof options.update === 'function') {
              options.update.apply(this, arguments);
            }
          },
          deeplink: function () {
            if (debug) {
              console.log(elementId + ': deeplink');
            }

            if (!$element.is(':first-child')) {
              TweenMax.to($window, 1, {
                scrollTo: $element.offset().top,
                onComplete: function () {
                  deeplinkMethods.deeplinking = false;
                  MAIN.update(true);
                }
              });
            } else {
              deeplinkMethods.deeplinking = false;
              MAIN.update(true);
            }

            // Ensure the deeplinking is "off" after a set time
            window.setTimeout(function () {
              deeplinkMethods.deeplinking = false;
              MAIN.update(true);
            }, 2000);

            if (typeof options.deeplink === 'function') {
              options.deeplink.apply(this, arguments);
            }
          }
        };
      }

      var postLoad = function () {
        // Resize handler that should trigger resize handling with a delay after a resize
        // Implementation done to throttle resize event calls
        var resizeHandler = _.debounce(function () {
          /*
						 Required for section load, unload, and update functions called by this function
						 There may be additional animations and functionality implemented in those functions that need to be called.
						 Calling this after resize insures that sections "now" in view get updated while sections that are "now" out of view are unloaded
					*/
          MAIN.update(true);

          // Add mobile class if desktop class scales under mobile size
          if (isDesktop) {
            if ($window.width() <= mobileSize && !$body.hasClass('mobile')) {
              $body.addClass('mobile');
              isMobile = true;
              $(window).trigger('desktopGainedMobile');
            } else if ($window.width() > mobileSize && $body.hasClass('mobile')) {
              $body.removeClass('mobile');
              isMobile = false;
              $(window).trigger('desktopLostMobile');
            }
          }
        }, 500);

        if (debug) {
          console.log('postLoad fired');
        }

        /*
					Scroll handling, also covers touchmove and touchend for smoother iOS updates
				*/
        $window.on('scroll touchmove touchend', function () {
          var $activeSections;

          /*
						 Required for section load, unload, and update functions called by this function
						 There may be additional animations and functionality implemented in those functions that need to be called.
					*/
          MAIN.update(true);

          $activeSections = $siteContainer.find('.vb_section.active');

          // Update deeplink if not currently deeplinking, if there are sections, and window isn't at maximum scroll
          if (!deeplinkMethods.deeplinking && $activeSections.length !== 0 && $window.scrollTop() !== $('body').height() - $(window).height()) {
            deeplinkMethods.setDeeplink('#/' + $activeSections.first().attr('id').replace(deeplinkMethods.deeplinkSectionIDPart, ''));
          }
          // Updated deeplink to last section if window is at maximum scroll
          // Implemented due to previous section catching deeplink conditions, while the last section almost never does
          else if ($window.scrollTop() === $('body').height() - $(window).height()) {
            deeplinkMethods.setDeeplink('#/' + $activeSections.last().attr('id').replace(deeplinkMethods.deeplinkSectionIDPart, ''));
          }
        });

        // on resize update MAIN and update desktop/mobile classes
        $window.resize(resizeHandler).trigger('resize');

        // Process products in product list against products in section 6, assigning classes for visual filtering.
        // MPP setup
        (function () {
          var $faceProducts = $siteContainer.find('#face_products'),
            $eyeProducts = $siteContainer.find('#eyes_products'),
            $lipsProducts = $siteContainer.find('#lips_products'),
            faceProducts = [],
            eyeProducts = [],
            lipsProducts = [],
            $products = $siteContainer.find('.mpp__product'),
            locations = [
              'london',
              'new-york',
              'la',
              'paris'
            ],
            customMPP,
            productsData;

          // Make sure page_data is not undefined
          // Continue doing this for proceeding properties until products array is hit
          if (typeof page_data !== 'undefined') {
            customMPP = page_data['custom-mpp'];
            if (typeof customMPP !== 'undefined') {
              productsData = customMPP['products'];
            }
          }

          // If there are no products, assume mobile version of site, which uses '.product-brief'
          if ($products.length === 0) {
            $products = $siteContainer.find('.product-brief');
          }

          // Populate products
          if ($faceProducts.length !== 0) {
            faceProducts = $faceProducts.html().split(',');
          }

          if ($eyeProducts.length !== 0) {
            eyeProducts = $eyeProducts.html().split(',');
          }

          if ($lipsProducts.length !== 0) {
            lipsProducts = $lipsProducts.html().split(',');
          }

          function trimProductIDs(arrProducts) {
            var p = 0;

            // Clear whitespace
            for (p = 0; p < arrProducts.length; p++) {
              arrProducts[p] = arrProducts[p].trim();
            }
          }

          // Ensure that whitespace has been cleared
          trimProductIDs(faceProducts);
          trimProductIDs(eyeProducts);
          trimProductIDs(lipsProducts);

          // Assign classes to products found in each category

          $products.each(function () {
            var $this = $(this),
              productID = $this.data('product-id'),
              p = 0,
              productData,
              skus,
              skuData;

            if (debug) {
              console.log('mpp labeler: looking for ' + productID + ' in ' + faceProducts, eyeProducts, lipsProducts);
            }

            if (faceProducts.indexOf(productID) !== -1) {
              $this.addClass('face');

              if (debug) {
                console.log('mpp labeler: found product: face ' + productID, $this);
              }
            } else if (eyeProducts.indexOf(productID) !== -1) {
              $this.addClass('eye');

              if (debug) {
                console.log('mpp labeler: found product: eye ' + productID, $this);
              }
            } else if (lipsProducts.indexOf(productID) !== -1) {
              $this.addClass('lips');

              if (debug) {
                console.log('mpp labeler: found product: lips ' + productID, $this);
              }
            } else if (debug) {
              console.log('mpp labeler: could not find in list product with ID ' + productID, $this);
            }

            // Assign SKUs per product based on page_data values (if it exists)
            // ... And is an Array
            if (typeof productsData !== 'undefined' && productsData instanceof Array) {
              for (p = 0; p < productsData.length; p++) {
                productData = productsData[p];
                if (typeof productData['PRODUCT_ID'] !== 'undefined' && productData['PRODUCT_ID'] === productID) {
                  skus = productData['skus'];
                  if (typeof skus !== 'undefined' && skus instanceof Array) {
                    // Use first sku data
                    skuData = skus[0];

                    if (typeof skuData['SKU_ID'] !== 'undefined') {
                      $this.attr('data-sku-base-id', skuData['SKU_ID']);
                      break;
                    }
                  }
                }
              }
            }
          });

          // Assign location classes to wrappers, assumes same order.
          $siteContainer.find('.mpp').not('.vb_section').each(function () {
            $(this).addClass(locations.shift());
          });

          // Update product positions as per vanilla Estee stuff
          // site.mpp_filter.adjustMppProductGrid();
        })();

        // Trigger postLoad event
        $window.trigger('postLoad');
      };

      /**
			* @function setProductsAndSkus
			* @description Assigns product IDs and SKUs to the .el-product elements
			* @param {jQuery} $selector Section to generate section data JS arguments from
			*/
      function setProductsAndSkus($selector) {
        var $products = $selector.find('.el-product'),
          $hiddenList = $selector.parent().find('.hidden_product_list'),
          productIDs = [],
          customMPP,
          productsData;

        // trim trailing comma and collect product IDs
        $hiddenList.text($hiddenList.text().slice(0, -1));
        productIDs = $hiddenList.text().split(',');

        // Make sure page_data is not undefined
        // Continue doing this for proceeding properties until products array is hit
        if (typeof page_data !== 'undefined') {
          customMPP = page_data['custom-mpp'];
          if (typeof customMPP !== 'undefined') {
            productsData = customMPP['products'];
          }
        }

        $products.each(function (index, element) {
          var $this = $(element),
            $thisShopButton = $this.find('.el-product_shop-now'),
            productID = productIDs[index],
            p = 0,
            productData,
            skus,
            skuData;

          // Add the product ID to the data-product value for this element
          $this.attr('data-product', productIDs[index]);
          $thisShopButton.attr('data-product', productIDs[index]);

          if (typeof productsData !== 'undefined' && productsData instanceof Array) {
            for (p = 0; p < productsData.length; p++) {
              productData = productsData[p];

              if (typeof productData['PRODUCT_ID'] !== 'undefined' && productData['PRODUCT_ID'] === productID) {
                skus = productData['skus'];

                if (typeof skus !== 'undefined' && skus instanceof Array) {
                  skuData = skus[0]; // Use first sku data

                  if (typeof skuData['SKU_ID'] !== 'undefined') {
                    $this.attr('data-sku', skuData['SKU_ID']);
                    $thisShopButton.attr('data-sku', skuData['SKU_ID']);
                    break;
                  }
                }
              }
            }
          }
        });
      }

      // Fires on postLoad to ensure _all_ content is loaded per slide before setting up section functionality
      $(window).on('postLoad', function () {
        // /////////////////////////////
        // BEGIN: General Events
        // /////////////////////////////

        // singular product quickshop/add to bag
        $siteContainer.find('.el-product_shop-now').on('click', function (e) {
          var $this = $(this);

          if ($this.hasClass('empty')) {
            return true;
          }

          e.preventDefault();

          // if shop button is tied to add-to-bag run addToCart, else do quickshop
          if ($this.hasClass('add-to-bag')) {
            // add the item to the cart
            site.addToCart({
              skuData: {
                SKU_BASE_ID: $this.attr('data-sku').substr(3),
                PARENT_CAT_ID: $this.attr('data-product')
              },
              quantity: 1,
              QTY: 1
            });
          } else {
            // console.log($this.data('full_product_json'));
            quickshop();
          }
        });
        // /////////////////////////////
        // END: General Events
        // /////////////////////////////

        // /////////////////////////////
        // BEGIN: Section 1
        // /////////////////////////////
        (function () {
          var $self = $siteContainer.find('#vb_section-1'),
            // Intro animation
            introTimeline,
            introPlayed = false,
            // DOM
            $logo = $self.find('.vb-logo'),
            $circles = $($self.find('object')[0].contentDocument).find('svg'),
            $backgroundImage = $self.find('.background'),
            $text = $self.find('.vb_section-full_text'),
            $signatureCover = $self.find('.vb_section-signature-image_cover');

          // Animation
          {
            introTimeline = new TimelineMax({
              paused: true,
              onComplete: function () {
                $self.addClass('introComplete');
              }
            });

            introTimeline
              .to($logo, 0.2, { opacity: 1 })

              .to($logo, 0.5, { opacity: 0 }, '+=0.7')
              .add([
                TweenMax.from($self.find('object'), 1.5, { opacity: 0 }),
                TweenMax.to($backgroundImage, 1.5, { opacity: 1 })
              ], '-=0.2')
              .staggerTo($circles.find('circle'), 0.1, { display: 'none' }, 0.1, '+=0.15');
          }

          MAIN.add(generateSection($self, {
            update: function (position) {
              var backgroundOffset, // Used for autoscroll
                backgroundHeight;

              if (!introPlayed && position >= 0.6) {
                // Intro animation parts for "scroll to" text as initial creation doesn't seem to catch
                // Background image heights correctly
                backgroundOffset = $backgroundImage.filter(isMobile ? '.mobile' : '.desktop').offset().top;
                backgroundHeight = $backgroundImage.filter(isMobile ? '.mobile' : '.desktop')[0].clientHeight;

                introTimeline
                  .to($window, 1, {
                    scrollTo: {
                      y: backgroundOffset + backgroundHeight,
                      autoKill: false
                    },
                    delay: 0.5
                  })
                  .add([
                    TweenMax.fromTo($text, 1, { y: '20%' }, {
                      y: '0%',
                      opacity: 1
                    }),
                    TweenMax.fromTo($signatureCover, 3, { left: '50%' }, { left: '100%' })
                  ], '+=0', 'normal', 0.2);

                introTimeline.play();
                introPlayed = true;
              }
            }
          }));
        })();
        // /////////////////////////////
        // END: Section 1
        // /////////////////////////////

        // /////////////////////////////
        // BEGIN: Section 2
        // /////////////////////////////
        (function () {
          var $self = $siteContainer.find('#vb_section-2'),
            // Intro Animation
            introTimeline,
            introAnimationStarted = false,
            // DOM
            $products = $self.find('.el-product'),
            $targetProducts,
            $text = $self.find('.vb_section-full_text'),
            // Rando,
            timeMax = 10000,
            timeMin = 3000,
            /**
					* @function timelineCompleteHandler
					* @description Handles introTimeline completion, first run completes any first-run functionality.
					* @returns {undefined} This function does not return anything
					*/
            timelineCompleteHandler = (function () {
              var run = false;

              /**
						* @function timeoutHandler
						* @description Helper function that (re)creates compact opening wave animation with associated timeouts; done due to callback issues with replaying timeline (all of them playing at once instead of timeline order specified)
						* @returns {undefined} This function does not return anything
						*/
              function timeoutHandler() {
                window.setTimeout(function () {
                  var timeline = new TimelineMax({ paused: true });

                  // Get animation targets in specified order if mobile
                  if (isMobile) {
                    $targetProducts = $([
                      $self.find('#compact-top-right'),
                      $self.find('#compact-center-right'),
                      $self.find('#compact-bottom-right'),
                      $self.find('#compact-center-highlighter'),
                      $self.find('#compact-top-left'),
                      $self.find('#compact-bottom-left')
                    ]);
                  } else {
                    $targetProducts = $products.not('.half');
                  }

                  $targetProducts.each(function () {
                    var $this = $(this);

                    $this.addClass('closed');
                    timeline.addCallback(function () {
                      $this.removeClass('intro closed');
                    }, '+=' + 0.5);
                  });

                  timeline.call(timelineCompleteHandler);
                  timeline.play();
                }, (timeMax - timeMin) * Math.random() + timeMin);
              }

              return function () {
                if (!run) {
                  // "Unlock" all products
                  $products.removeClass('intro');

                  // Display section text once only
                  TweenMax.fromTo($text, 1, { y: '20%' }, {
                    y: '0%',
                    opacity: 1,
                    delay: 0.25
                  });

                  run = true;

                  // Start repeating open close animation
                  timeoutHandler();
                }
                // Continue repeating open close animation
                else {
                  timeoutHandler();
                }
              };
            })();

          // Animations
          {
            // Get animation targets in specified order if mobile
            if (isMobile) {
              $targetProducts = $([
                $self.find('#compact-top-right'),
                $self.find('#compact-center-right'),
                $self.find('#compact-bottom-right'),
                $self.find('#compact-center-highlighter'),
                $self.find('#compact-top-left'),
                $self.find('#compact-bottom-left')
              ]);
            } else {
              $targetProducts = $products.not('.half');
            }

            // Prep products for animation via adding 'intro' class to put them into closed state
            $targetProducts.addClass('intro');

            introTimeline = new TimelineMax({ paused: true });
            $targetProducts.each(function () {
              var $this = $(this);

              introTimeline.addCallback(function () {
                $this.removeClass('intro closed');
              }, '+=' + 0.5);
            });
            introTimeline.call(timelineCompleteHandler);
          }

          MAIN.add(generateSection($self, {
            update: function (position) {
              if (!introAnimationStarted && position >= 0.6) {
                introAnimationStarted = true;
                introTimeline.play();
              }
            }
          }));
        })();
        // /////////////////////////////
        // END: Section 2
        // /////////////////////////////

        // /////////////////////////////
        // BEGIN: Section 3
        // /////////////////////////////
        (function () {
          var $self = $siteContainer.find('#vb_section-3'),
            // Intro animation
            introTimeline,
            introTimelineStarted = false,
            // DOM
            $columns = $self.find('.columns-container').children();

          {
            introTimeline = new TimelineMax({
              paused: true
            });

            introTimeline
              .staggerFrom($columns, 1, {
                y: '20%',
                opacity: 0,
                clearProps: 'transform'
              }, 0.5);
          }

          MAIN.add(generateSection($self, {
            update: function (position) {
              if (!introTimelineStarted && position >= 0.4) {
                introTimeline.play();
                introTimelineStarted = true;
              }
            }
          }));
        })();
        // /////////////////////////////
        // END: Section 3
        // /////////////////////////////

        // /////////////////////////////
        // BEGIN: Section 4
        // /////////////////////////////
        (function () {
          var $self = $siteContainer.find('#vb_section-4'),
            // Intro animation
            introTween,
            introTweenStarted = false,
            // DOM
            $text = $self.find('.vb_section-full_text');

          {
            introTween = TweenMax.fromTo($text, 0.5, { y: '20%' }, {
              y: '0%',
              opacity: 1,
              paused: true
            });
          }

          MAIN.add(generateSection($self, {
            update: function (position) {
              if (!introTweenStarted && position >= 0.4) {
                introTween.play();
                introTweenStarted = true;
              }
            }
          }));
        })();
        // /////////////////////////////
        // END: Section 4
        // /////////////////////////////

        // ////////////////////////////
        // BEGIN: Section 5
        // /////////////////////////////
        (function () {
          var $self = $siteContainer.find('#vb_section-5'),
            // Intro animation
            introTimeline,
            introTimedlineStarted = false,
            // Mobile animation vars
            $currentSlide,
            // DOM
            $carousel = $self.find('.carousel'),
            $arrowLeft = $self.find('.carousel_pagers .arrow.left'),
            $arrowRight = $self.find('.carousel_pagers .arrow.right'),
            $pagination = $self.find('.carousel_pagination .dot');

          // Create carousel, this will be disabled or enabled based on current mode
          $carousel.el_carousel({
            useGSAP: true,
            increment: '100%',
            duration: 0.5
          });

          /**
					* @function setMobileMode
					* @description Clears events used for desktop
					* @returns {undefined} this function does not return anything
					*/
          function setMobileMode() {
            if (debug) {
              console.log('#vb_section-5: setMobileMode');
            }

            // Clear carousel stuff
            $carousel.carouselSetEnabled(false);
            $carousel
              .children()
              .css('left', '')
              .find('.columns-container.see-the-look')
              .filter('.mobileFinished')
              .css({
                opacity: '0',
                display: 'none'
              });

            // Clear see-the-look-active class
            $self.removeClass('see-the-look-active');

            // Unbind and disable events
            $arrowLeft.off('click');
            $arrowRight.off('click');
            $pagination.off('click');
            $carousel.off('carousel_updated');
            $window.off('keydown');
            $self.swipe('disable');
          }

          /**
					* @function setDesktopMode
					* @description Creates events needed for desktop functionality
					* @returns {undefined} This function doesn't return anything
					*/
          function setDesktopMode() {
            if (debug) {
              console.log('#vb_section-5: setDesktopMode');
            }

            $currentSlide = $();

            // Enable carousel
            $carousel.carouselSetEnabled(true);
            $carousel.carouselUpdate();
            $carousel
              .children()
              .not('.active')
              .find('.columns-container.see-the-look')
              .css({
                opacity: '1',
                transform: ''
              });

            // Clear see-the-look-active class
            $self.removeClass('see-the-look-active');

            // Carousel controls
            $arrowLeft.on('click', function (e) {
              e.preventDefault();
              $carousel.carouselPrev();
            });

            $arrowRight.on('click', function (e) {
              e.preventDefault();
              $carousel.carouselNext();
            });

            $pagination.on('click', function (e) {
              var $this = $(this),
                index = $this.index();

              e.preventDefault();

              // Do not allow carousel if see the look is actuve
              if ($self.hasClass('see-the-look-active')) {
                return;
              }

              $this.addClass('active').siblings().removeClass('active');
              $carousel.carouselTo(index);
            });

            // Updates the pagination dots when carousel updates
            $carousel.on('carousel_updated', function (e, index) {
              var $slide = $carousel.children().eq(index),
                $top = $slide.find('.columns-container').filter('.see-the-look');

              $pagination.eq(index).addClass('active').siblings().removeClass('active');

              // Top see-the-look fadeout
              TweenMax.to($top, 0.5, {
                opacity: 0,
                display: 'none',
                delay: 1
              });
              // TweenMax.set($slide.siblings().find('.see-the-look'), {opacity: 1, display: 'table'});
            });

            $window.on('keydown', function (e) {
              // e.preventDefault();
              // using preventDefault on $window will block user input on search input fields

              if (!$self.hasClass('active')) {
                return;
              }

              // Do not allow carousel if see the look is actuve
              if ($self.hasClass('see-the-look-active')) {
                return;
              }

              switch (e.which) {
                // Left arrow
                case 37:

                  $carousel.carouselPrev();
                  break;

                  // Right arrow
                case 39:

                  $carousel.carouselNext();
                  break;
              }
            });

            $self.swipe('enable');
          }

          /**
					* @function crossToggle
					* @description Handles panel opening when mousing over/out or clicking on the plus images found on slides. Must be called with call or apply for scoping
					* @param {object} e - Event Object
					* @param {boolean} enable - Override to open or close panel, true to open, false to close
					* @returns {undefined} This function does not return anything
					*/
          function crossToggle(e, enable) {
						 /* jshint validthis: true */
            var $this = $(this),
              $slide = $this.closest('.slide'),
              $crossPlus = $this.find('a'),
              $panel = $slide.find('.panel'),
              $panelText = $slide.find('.vb_section-half_text');

            e.preventDefault();

            console.log('test', $crossPlus.hasClass('open'), $crossPlus.hasClass('close'));

            if ($crossPlus.hasClass('open') || (typeof enable !== 'undefined' && enable)) {
              $crossPlus.removeClass('open').addClass('close');

              // Ensure tweens are stopped for each element
              TweenMax.killTweensOf($crossPlus);
              TweenMax.killTweensOf($panel);
              TweenMax.killTweensOf($panelText);

              TweenMax.to($crossPlus, 0.1, {
                rotation: 45,
                zIndex: 1
              });
              if (!isMobile) {
                TweenMax.to($panelText, 0.3, { opacity: 0 });
              }
              TweenMax.to($panel, 0.3, {
                opacity: 1,
                display: 'block'
              });
            } else if ($crossPlus.hasClass('close') || (typeof enable !== 'undefined' && !enable)) {
              $crossPlus.addClass('open').removeClass('close');

              // Ensure tweens are stopped for each element
              TweenMax.killTweensOf($crossPlus);
              TweenMax.killTweensOf($panel);
              TweenMax.killTweensOf($panelText);

              TweenMax.to($crossPlus, 0.1, {
                rotation: 0,
                zIndex: 0
              });
              if (!isMobile) {
                TweenMax.to($panelText, 0.3, { opacity: 1 });
              }
              TweenMax.to($panel, 0.3, {
                opacity: 0,
                display: 'none'
              });
            }
          }

          function seeTheLookCloseButtonClickHandler(e) {
            var $this = $(this),
              closeTimeline = new TimelineMax({
                paused: true,
                onComplete: function () {
                  $self.removeClass('see-the-look-active');
                }
              }),
              $seeTheLook = $this.closest('.see-the-look');

            e.preventDefault();

            closeTimeline
              .to($seeTheLook, 1, {
                display: 'none',
                opacity: 0
              })
              .to($seeTheLook.find('.close-panel'), 1, {
                opacity: 0,
                display: 'none'
              });
            closeTimeline.play();
          }

          {
            introTimeline = new TimelineMax({
              paused: true,
              onComplete: function () {
                $self.removeClass('intro');
              }
            });

            if (isMobile) {
              $currentSlide = $carousel.find('.first');
              TweenMax.set($carousel.children(), {
                y: '20%',
                opacity: 0
              });
              TweenMax.set($siteContainer.find('.see-the-look'), {
                opacity: 1,
                display: 'block'
              });

              introTimeline
                .from($currentSlide, 1, {
                  y: '20%',
                  opacity: 0
                });
            } else {
              TweenMax.set($arrowLeft.add($arrowRight).find('img'), { opacity: 0 });

              introTimeline
                .from($carousel.children().first(), 1, {
                  x: '15%',
                  opacity: 0,
                  clearProps: 'transform'
                })
                .to($carousel.children().first().find('.column'), 1, { opacity: 1 }, '-=1')
                .to($arrowLeft.add($arrowRight).find('img'), 1, {
                  opacity: 1,
                  delay: 0.2,
                  clearProps: 'all'
                })
                .to($carousel.children().first().find('.see-the-look'), 1, {
                  opacity: 0,
                  display: 'none'
                });
            }
          }

          {
            // See the look button, displays .see-the-look in the slide for 2 secs
            $siteContainer.find('.see-the-look-button a').on('click', function (e) {
              var $this = $(this),
                $seeTheLook = $this.closest('.slide').find('.see-the-look'),
                lookTimeline = new TimelineMax();

              e.preventDefault();

              // Mark section for see-the-look as active
              $self.addClass('see-the-look-active');

              TweenMax.killTweensOf($seeTheLook);

              lookTimeline
                .to($seeTheLook, 1, {
                  display: 'table',
                  opacity: 1
                })
                .from($seeTheLook, 1, { y: '+=5%' }, 0)
                .to($seeTheLook.find('.close-panel'), 0.5, {
                  opacity: 1,
                  display: 'block'
                }, 0);

              /*
								.add([
									TweenMax.to($seeTheLook, 1, {display: 'none', opacity: 0}),
									TweenMax.to($seeTheLook.find('.close-panel'), {opacity: 0})
								], '+=2');
								*/
            });

            $self.find('.see-the-look .close-panel').on('click', seeTheLookCloseButtonClickHandler);

            // Swipe events, this will be enabled/disabled via setDesktopMode/setMobileMode
            $self.swipe({
              swipeLeft: function () {
                if ($self.hasClass('see-the-look-active')) {
                  return;
                }

                $carousel.carouselNext();
              },
              swipeRight: function () {
                if ($self.hasClass('see-the-look-active')) {
                  return;
                }

                $carousel.carouselPrev();
              },
              allowPageScroll: 'vertical',
              preventDefaultEvents: false
            });

            // Enable or disable desktop/mobile functionality
            if (!isMobile) {
              setDesktopMode();
            } else {
              setMobileMode();
            }

            // Events to trigger desktop/mobile functionality
            $(window)
              .on('desktopLostMobile', setDesktopMode)
              .on('desktopGainedMobile', setMobileMode);

            // Displays the right side swatches on click, rotates the plus sign from + to x
            $carousel.find('.open-panel')
              .on('mouseenter', function (e) {
                e.preventDefault();

                if (!(isMobile || isIpad)) {
                  crossToggle.apply(this, [e, true]);
                }
              })
              .on('mouseleave', function (e) {
                e.preventDefault();

                if (!(isMobile || isIpad)) {
                  crossToggle.apply(this, [e, false]);
                }
              })
            // Mobile only, as 'hover' doesn't work or is weirdly handled
              .on('click', function (e) {
                e.preventDefault();

                if (isMobile || isIpad) {
                  crossToggle.apply(this, [e]);
                }
              });

            $carousel.find('.slide').find('.el-product_shop-now-container:not(.see-the-look-button) .el-product_shop-now').on('click', function (e) {
              var $this = $(this),
                $mppSection = $siteContainer.find('#vb_section-6'),
                classes = $this.attr('class').split(' ');

              if ($this.hasClass('empty')) {
                return true;
              }
              e.preventDefault();

              // TweenMax.killTweensOf($window);
              // TweenMax.to($window, 1, {scrollTo: {y: $mppSection.offset().top}});

              // Toggle current location MPP choice
              $mppSection.find('#mpp-location ul').find('.' + classes[1]).trigger('click');
              // Toggle active on the currently active product filter
              $mppSection.find('#mpp-category-container li.active').trigger('click');
            });
          }

          MAIN.add(generateSection($self, {
            update: function (position) {
              if (!introTimedlineStarted && position >= 0.4) {
                introTimeline.play();
                introTimedlineStarted = true;
              }

              // When in mobile $currentSlide's bottom reaches near or past the top, animate in the next slide
              if (isMobile && $self.find('.mobilefinished').length !== $self.find('.slide').length) {
                $carousel.children().each(function () {
                  var $this = $(this),
                    slideTimeline = new TimelineMax({
                      paused: true,
                      onComplete: function () {
                        $this.addClass('mobilefinished');
                      }
                    });

                  if ($this.offset().top < $window.scrollTop() + $window.height()) {
                    if ($this.hasClass('mobileStarted')) {
                      return;
                    }

                    $this.addClass('mobileStarted');

                    slideTimeline
                      .to($this, 1, {
                        y: '0%',
                        opacity: 1
                      })
                      .to($this.find('.see-the-look'), 1, {
                        opacity: 0,
                        display: 'none'
                      }, '+=1');

                    slideTimeline.play();
                  }
                });
              }
            }
          }));
        })();
        // /////////////////////////////
        // END: Section 5
        // /////////////////////////////

        // /////////////////////////////
        // BEGIN: Section 6 MPP
        // /////////////////////////////
        (function () {
          var $self = $siteContainer.find('#vb_section-6'),
            $locationFilter = $self.find('#mpp-location ul li'),
            $categoryFilter = $self.find('#mpp-category-container ul li');

          // Init section with initial products to display
          {
            $locationFilter.removeClass('active');
            $categoryFilter.removeClass('active');

            // Store class targets to update section with
            $locationFilter.each(function () {
              var $this = $(this);

              $this.data('target', $this.attr('class'));
            });

            // First location gets active
            $locationFilter.first().addClass('active');
            $self.addClass($locationFilter.first().data('target'));
          }

          {
            // add all to bag per city
            $siteContainer.find('.mpp_shop-all').on('click', function (e) {
              e.preventDefault();

              var $this = $(this),
                // long ternary operator just checks this for city name
                // Get all products for city
                cityName = $this.hasClass('london') ? 'london' : $this.hasClass('new-york') ? 'new-york' : $this.hasClass('la') ? 'la' : $this.hasClass('paris') ? 'paris' : '',
                $cityProducts = $('.mpp.' + cityName).find('.mpp__product'),
                productData,
                productsToLoad = [],
                productLoadInterval;

              // Assume mobile version of site if no .mpp__product's are found
              if ($cityProducts.length === 0) {
                $cityProducts = $siteContainer.find('.mpp.' + cityName).find('.product-brief');
              }

              // iterate through found products, collect their prod ID and sku ID attributes.
              // use those attributes for addToCart call
              $cityProducts.each(function () {
                var $this = $(this);

                productsToLoad.push({
                  productID: $this.data('product-id'),
                  skuID: $this.data('sku-base-id').replace(/[A-z]+/, '') // On Mobile Estee, SKUs only take numbers only; i.e., 9515, not SKU9515
                });
              });
              // Start loading products
              productData = productsToLoad.pop();
              site.addToCart({
                skuData: {
                  SKU_BASE_ID: productData.skuID,
                  PARENT_CAT_ID: productData.productID
                },
                quantity: 1,
                QTY: 1
              });

              // Load products over an interval
              productLoadInterval = window.setInterval(function () {
                productData = productsToLoad.pop();

                site.addToCart({
                  skuData: {
                    SKU_BASE_ID: productData.skuID,
                    PARENT_CAT_ID: productData.productID
                  },
                  quantity: 1,
                  QTY: 1
                });

                if (productsToLoad.length === 0) {
                  window.clearInterval(productLoadInterval);
                }
              }, 2000);
            });

            $locationFilter.on('click touchstart', function (e) {
              var $this = $(this),
                $targetMPP;

              e.preventDefault();
              e.stopPropagation();

              $targetMPP = $siteContainer.find('.mpp' + '.' + $this.data('target'));

              if ($targetMPP.length !== 0) {
                TweenMax.to($window, 1, {
                  scrollTo: {
                    y: $targetMPP.offset().top,
                    autoKill: false
                  }
                });
              }
            });

            $categoryFilter.on('click touchstart', function (e) {
              var $this = $(this);

              e.preventDefault();
              e.stopPropagation();

              if (!$this.hasClass('active')) {
                $this.addClass('active').siblings().removeClass('active');
              } else {
                $this.removeClass('active');
              }

              // Blow out classes
              $categoryFilter.each(function () {
                $siteContainer.removeClass($(this).data('slot_name'));
              });

              if ($this.hasClass('active')) {
                $siteContainer.addClass($this.data('slot_name'));
              }

              // Update product positions as per vanilla Estee stuff
              // site.mpp_filter.adjustMppProductGrid();
            });
          }

          MAIN.add(generateSection($self, {}));
        })();
        // /////////////////////////////
        // END: Section 6 MPP
        // /////////////////////////////
      });

      // /////////////////////////////////
      // BEGIN: COREMETRICS
      // /////////////////////////////////
      (function () {
        if (window.location.href.indexOf('dynamic.li') > -1) {
          return;
        }

        var forceFlag = $siteContainer.hasClass('it_IT') ? 1 : 0;
        var cmSettings = {
          options: {
            debug: debug,
            cat_id: 'CAT', // CAT ID
            element_cat: 'Estee Supreme Boutique', // Boutique Name
            force: forceFlag// Force CoreMetrics on some servers
          },
          section: [
            {
              tag: 'Landing',
              element_tag: {

              }
            }
          ]
        };

        $siteContainer.elmetrics(cmSettings);
      })();
      // ///////////////////////////////////
      // END: COREMETRICS
      // ///////////////////////////////////

      // /////////////////////////////////
      // BEGIN: Preloader
      // /////////////////////////////////

      (function () {
        var
          $loader = $siteContainer.find('#loader'),
          preloadTargets = [],
          spinnerOptions = {
            lines: 17, // The number of lines to draw
            length: 0, // The length of each line
            width: 5, // The line thickness
            radius: 26, // The radius of the inner circle
            scale: 1, // Scales overall size of the spinner
            corners: 1, // Corner roundness (0..1)
            color: '#fff', // #rgb or #rrggbb or array of colors
            opacity: 0.5, // Opacity of the lines
            rotate: 0, // The rotation offset
            direction: 1, // 1: clockwise, -1: counterclockwise
            speed: 1, // Rounds per second
            trail: 30, // Afterglow percentage
            zIndex: 2e9, // The z-index (defaults to 2000000000)
            className: 'spinner', // The CSS class to assign to the spinner
            top: '50%', // Top position relative to parent
            left: '50%', // Left position relative to parent
            shadow: false, // Whether to render a shadow
            hwaccel: true, // Whether to use hardware acceleration
            position: 'absolute' // Element positioning
          },
          spinner = new Spinner(spinnerOptions).spin($loader[0]),
          $deeplinkSection = deeplinkMethods.getDeeplink(),
          // Object/SVG loading
          $objects = $siteContainer.find('object'),
          objectsToLoad = $objects.length,
          objectsLoaded = 0;

        /**
				* @function triggerPreload
				* @description Helper function for preload
				* @returns {undefined} This function doesn't return anything
				*/
        function triggerPreload() {
          if (debug) {
            console.log('triggerPreload: Preload Triggered');
          }

          $(preloadTargets).FreeLoader({
            debug: false,
            loadTimeout: 10000,
            callback: function () {
              // Ensure the rest of the images have been swapped in
              $siteContainer.find('img, .preload').each(function () {
                var $this = $(this),
                  dataSrc = $this.data('src');

                if (typeof dataSrc !== 'undefined') {
                  $this.attr('src', dataSrc);
                }
              });

              // Delay used to ensure enough images are loaded before displaying site
              TweenMax.to($loader, 1, {
                opacity: 0,
                display: 'none',
                delay: 2,
                onComplete: function () {
                  spinner.stop();
                  $window.trigger('scroll');

                  // Deeplink handling
                  if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0 && typeof $deeplinkSection.data('section') !== 'undefined') {
                    $deeplinkSection.data('section').deeplink();
                  }
                // TweenMax.to($window, 1, {scrollTo: {y: $deeplinkSection.offset().top}});
                }
              });
              postLoad();
            }
          });
        }

        // parse Prod ID list, match with SKUs in page_data and assign them to the el-product elements
        setProductsAndSkus($siteContainer.find('.vb_section-2_product-hover'));
        setProductsAndSkus($siteContainer.find('#vb_section-3 div.column.left'));
        setProductsAndSkus($siteContainer.find('.vb_section-5_london-hovers'));
        setProductsAndSkus($siteContainer.find('.vb_section-5_ny-hovers'));
        setProductsAndSkus($siteContainer.find('.vb_section-5_la-hovers'));
        setProductsAndSkus($siteContainer.find('.vb_section-5_paris-hovers'));

        // Run EL Product plugin
        $('#vb_section-2, #vb_section-3, #vb_section-5').elproduct({
          'target': '.el-product',
          'template': '.el-product_template-markup .el-product',
          'products': '.el-product_id-list',
          // 'products' : '.hidden_product_list',
          'debug': false
        });

        // Deeplink'd section gets priority over all other sections
        preloadTargets.push($deeplinkSection.find('img, .preload').not(isMobile ? '.desktop' : '.mobile'));
        $siteContainer.find('.vb_section').not($deeplinkSection).each(function () {
          preloadTargets.push($(this).find('img, .preload').not(isMobile ? '.desktop' : '.mobile'));
        });

        if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
          deeplinkMethods.deeplinking = true;
        }

        // Load objects if there are any, otherwise skip to image preloading
        if (objectsToLoad !== 0) {
          if (debug) {
            console.log('Found: ' + objectsToLoad, $objects);
          }

          // Attach load event to each object
          $objects.each(function () {
            var $this = $(this);

            // Object must have data set and not blank, if so decrement and don't listen for load
            if (typeof $this.attr('data') === 'undefined' || $this.attr('data').trim().length === 0 || $this.hasClass('loaded')) {
              if (debug) {
                console.log('No data to load from: ', $this);
              }

              objectsToLoad--;

              if (objectsToLoad === 0) {
                triggerPreload();
              }

              return;
            }

            if (debug) {
              console.log('Loading data for: ', $this);
            }

            this.addEventListener('load', function () {
              objectsLoaded++;

              if (debug) {
                console.log('Loaded: ', $this);
              }

              // Trigger normal image preloading after objects have loaded
              if (objectsLoaded >= objectsToLoad) {
                triggerPreload();
              }
            });
          });
        } else {
          triggerPreload();
        }
      }());

      // /////////////////////////////////
      // END: Preloader
      // /////////////////////////////////
    }());
    // /////////////////////////////////
    // END: Boutique Implementation
    // /////////////////////////////////
  }
};
